function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.37 65.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.58,1.08C1.52,3.85.88,8.73,4.03,20.55l1.9,7.12-2.92,10.88C.22,48.93-.81,60.43.69,64.35c.33.87,1.67,1.58,2.96,1.58,1.93,0,2.55-.76,3.44-4.25,3.54-13.92,7.99-26.01,10.02-27.27.56-.34.97.86.97,2.82s.46,5.85,1.02,8.81c.89,4.66.74,6.16-1.11,11.12-1.18,3.15-1.87,6.45-1.53,7.32.97,2.54,4.64,1.29,7.82-2.66,3.41-4.22,5.7-14.89,5.77-26.89.03-4.12.74-9.75,1.58-12.5,4.48-14.61-.09-24.95-9.57-21.64-2.01.7-3.91.74-5.58.1-3.3-1.25-7.4-1.17-9.9.19",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.94,3.35c1.78.92,3.27,1.1,4.2.51.79-.5,2.88-.92,4.63-.93,5.83-.03,7.78,6.27,5.16,16.66l-1.15,4.56-4.6-.72c-2.53-.39-7.52-1.01-11.09-1.36l-6.48-.65-1.44-6.23c-1.64-7.1-.72-10.68,3.14-12.24,3.21-1.29,4.49-1.22,7.62.39",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.08,24.97c10.39,1.65,10,1.35,10,7.77,0,10.19-2.62,23.01-5.61,27.53-3.18,4.8-4.31,3.42-1.98-2.41,1.27-3.18,1.47-6.01.95-13.89-.36-5.44-.99-10.44-1.4-11.11-.45-.72-1.74-.96-3.21-.59-2.91.73-7.37,10.43-10.6,23.04-1.1,4.28-2.31,8.09-2.69,8.45-.39.36-.47-4.29-.19-10.34.35-7.6,1.16-12.83,2.62-16.91,1.16-3.25,2.11-7.41,2.11-9.25,0-3.83.14-3.86,10-2.3",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/46.73d3774c71be2b6c590eb59d7c1188da.svg";
export { ForwardRef as ReactComponent };